<div class="container-fluid middle content-main">
    <div class="row align-items-center">
        <div class="col mx-auto">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<nav class="navbar bg-primary fixed-bottom">
    <div class="container nav-reserve-bottom">
        <button *ngIf="showPreviousBt" class="nav-link btn btn-outline-neutral btn-lg btn-reserve-back" (click)="goBack()">
            <i class="nc-icon nc-minimal-left" aria-hidden="true"></i>&nbsp;{{'bt.back'|traduccion}}
        </button>
        <div class="ml-md-auto btn-reserve-pay">
            <div class="c-bt-next">
                <button *ngIf="showNextBt" class="nav-link btn btn-outline-neutral btn-lg  {{enabledNextBt ? '' : 'disabled'}}"
                    (click)="clickCallNext('callNext')">{{nameNextBt}}&nbsp;
                    <i class="nc-icon nc-minimal-right" aria-hidden="true"></i>
                </button>
            </div>
            
            <div class="c-bt-pay">
                <button *ngIf="showPaymentBt && !showPaymentFreeBt" (click)="clickAction('checkoutCardStripe')"
                class="btn btn-outline-neutral btn-lg btn-fill bt-card">
                    <div class="p-0 m-0">
                        <img src="/assets/svg/card_visa.svg" />
                        <img src="/assets/svg/card_american_express.svg" />
                        <img src="/assets/svg/card_mastercard.svg" />
                    </div>
                </button>
                <button *ngIf="showPaymentBt && showPaymentPaypalBt && !showPaymentFreeBt" (click)="clickAction('checkoutCardPaypal')"
                    class="btn btn-neutral btn-lg btn-fill bt-paypal">
                </button>
                <button *ngIf="showPaymentFreeBt" (click)="clickAction('checkoutFree')"
                    class="btn btn-neutral btn-lg btn-fill">{{'bt.getFree'|traduccion}}
                </button>
            </div>
        </div>
    </div>
</nav>